export class IServiceError {
  errorNumber: number;
  message: string;
  friendlyMessage: string;
  errorMessage: string;
  errorStatus: number;
  name: string;
  url: string;
}
